
<template>
  <div>
    <v-dialog v-model="dialog" max-width="800px" persistent scrollable transition="dialog-transition">
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <h3 class="headline mb-0">Vencer negociação</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-radio-group v-model="win_all" column row>
            <v-radio :value="true" type="success">
              <template v-slot:label>
                <div>Negociação ganha com <strong class="success--text">todos os itens</strong></div>
              </template>
            </v-radio>
            <v-radio :value="false" color="primary">
              <template v-slot:label>
                <div>Negociação ganha com <strong class="primary--text">alguns itens</strong></div>
              </template>
            </v-radio>
          </v-radio-group>

          <list-item v-if="!win_all" is_winning :show_crud_item="false" :items="last_deal.deal_items"></list-item>

          <template v-if="setup_shipping_done && (!allDrivers || !allTrucks)">
            <v-alert type="info" :value="true" style="border-radius: 8px;">
              Carregando dados para o frete...
              <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
            </v-alert>
          </template>

          <template v-if="setup_shipping_done && allDrivers && allTrucks">
            <v-form ref="winDealForm" lazy-validation>
              <v-subheader>Detalhes dos fretes</v-subheader>
              <div v-for="(ship, idx) in shipping_data" :key="'sp' + idx" class="px-3 mb-2"
                style="border: solid 1px #eee; border-radius: 12px;">
                <v-subheader>{{ idx + 1}} - Frete para os itens: {{ ship.deal_item_names.join(', ') }}
                  ({{ ship.shipping_value.total_bags }} sacos)</v-subheader>
                <v-row>
                  <v-col cols='6'>
                    <v-switch
                      :label="ship.shipping_value.delivery_attributes.internal ? 'Frete interno' : 'Frete Externo'"
                      class="ml-3" color="blue" v-model="ship.shipping_value.delivery_attributes.internal"></v-switch>
                  </v-col>
                  <v-col cols='6'>
                    <v-dialog ref="dialog" :return-value.sync="ship.shipping_value.delivery_attributes.estimatedLoading"
                      width="290px">
                      <template v-on="{ on }">
                        <v-text-field v-on="on"
                          :value="new Date(ship.shipping_value.delivery_attributes.estimatedLoading.substring(0, 10) + 'T12:00:00').toLocaleDateString('pt-BR')"
                          label="Data de carregamento" prepend-icon="mdi-calendar" readonly
                          :rules="[rules.required]"></v-text-field>
                      </template>
                      <v-date-picker v-model="ship.shipping_value.delivery_attributes.estimatedLoading" color="primary"
                        locale="pt-br" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text icon color="success"
                          @click="$refs.dialog[idx].save(ship.shipping_value.delivery_attributes.estimatedLoading)"><v-icon>mdi-check</v-icon></v-btn>
                        <v-spacer></v-spacer>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col cols='6'>
                    <v-autocomplete :loading="!allDrivers" v-model="ship.shipping_value.delivery_attributes.driver_id"
                      :items="all_drivers(ship.shipping_value.delivery_attributes.internal)"
                      :label="'Motorista ' + (ship.shipping_value.delivery_attributes.internal ? 'interno' : 'externo')"
                      prepend-icon="mdi-account-box" item-text="name" item-value="id" :rules="[rules.required]">
                      <template v-slot:no-data>
                        <span> Motorista não cadastrado </span>
                      </template>
                      <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols='6'>
                    <v-autocomplete :loading="!allTrucks" v-model="ship.shipping_value.delivery_attributes.truck_id"
                      :items="all_trucks(ship.shipping_value.delivery_attributes.internal)"
                      :label="'Caminhão ' + (ship.shipping_value.delivery_attributes.internal ? 'interno' : 'externo')"
                      prepend-icon="mdi-truck" item-text="plate" item-value="id" :rules="[rules.required]">
                      <template v-slot:no-data>
                        <span> Caminhão não cadastrado </span>
                      </template>
                      <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols='6'>
                    <v-text-field ref="mon" v-model="ship.shipping_value.bag_shipping_price" v-money="money_three_digit"
                      label="Frete unitário (R$)" prepend-icon="mdi-cash"></v-text-field>
                  </v-col>
                  <v-col cols='6'>
                    <v-text-field readonly label="Frete total (R$)" prepend-icon="mdi-cash"
                      :value="`R$ ${(Number(ship.shipping_value.bag_shipping_price) * ship.shipping_value.total_bags).toFixed(2)}`"></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-form>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <f-btn @click="close()" cancel></f-btn>
          <v-btn v-if="!setup_shipping_done" color="primary" @click="setupShippingData()" small>
            <v-icon left size="19" small>mdi-truck</v-icon> Preparar fretes
          </v-btn>
          <v-btn v-if="setup_shipping_done" color="success" @click="startWinDeal()" small>
            <v-icon left size="19">mdi-check</v-icon>Vencer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  components: {
    ListItem: () => import('./listItems.vue'),
  },
  props: {
    last_deal: {
      type: Object,
    },
    updateDeal: {
      type: Function
    }
  },
  data() {
    return {
      dialog_loading: false,
      dialog: true,
      win_all: true,
      shipping_data: {},
      shipping_value: {
        delivery_attributes: {
          internal: null,
          driver_id: null,
          truck_id: null,
          truck_plate: null,
          total_shipping_price: null,
          estimatedLoading: new Date().toISOString().substring(0, 10),
        },
        bag_shipping_price: '0.0000',
        total_bags: 0,
      },
      money_three_digit: {
        decimal: '.',
        thousands: ',',
        precision: 4,
        masked: false
      },

      setup_shipping_done: false,


      rules: {
        required: v => !!v || 'Campo é necessário',
        notZeroPercentage: v => (!!v && v != '0.00' && parseFloat(v) < 100) || 'Formato válido: "99.99"',
        notZero: v => v != '0.00' || 'Não pode ser zero',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
    }
  },
  methods: {
    setupShippingData() {
      let s_data = {}
      let all_won = []
      if (this.win_all) {
        all_won = this.last_deal.deal_items
      } else {
        if (!this.last_deal.deal_items.filter(o => o.status == 'open').length) {
          all_won = this.last_deal.deal_items.filter(o => o.status == 'won')
        } else {
          alert('Favor indicar quais itens foram ganhos e quais foram perdidos')
          return
        }
      }
      all_won.forEach(di => {
        if (s_data[di.pickup_location_id]) {
          s_data[di.pickup_location_id].shipping_value.total_bags += Number(di.total_bags)

          s_data[di.pickup_location_id].deal_item_ids.push(di.id)
          s_data[di.pickup_location_id].deal_item_names.push(di.brand_product_name)
        } else {
          s_data[di.pickup_location_id] = {
            deal_item_ids: [di.id],
            deal_item_names: [di.brand_product_name],
            shipping_value: {
              delivery_attributes: {
                internal: null,
                driver_id: null,
                truck_id: null,
                truck_plate: null,
                total_shipping_price: null,
                estimatedLoading: new Date().toISOString().substring(0, 10),
              },
              bag_shipping_price: '0.0000',
              total_bags: Number(di.total_bags)
            }
          }
        }
      });
      this.shipping_data = [...Object.values(s_data)]
      this.setup_shipping_done = true
    },
    close() {
      this.last_deal.deal_items = this.last_deal.deal_items.map(o => { return { ...o, status: 'open' } })
      this.dialog = false
    },
    startWinDeal() {
      if (this.$refs.winDealForm.validate()) {
        if (this.win_all) {
          this.last_deal.deal_items = this.last_deal.deal_items.map(o => { return { ...o, status: 'won' } })
        }
        this.shipping_data.forEach(ship => {
          ship.shipping_value.delivery_attributes.truck_plate = this.all_trucks(ship.shipping_value.delivery_attributes.internal).find(o => o.id == ship.shipping_value.delivery_attributes.truck_id).plate
          ship.shipping_value.delivery_attributes.total_shipping_price = (Number(ship.shipping_value.bag_shipping_price) * ship.shipping_value.total_bags).toFixed(2)
        });

        this.last_deal.shipping_data = [
          ...this.shipping_data
        ]

        if (this.updateDeal()) {
          this.updateDeal()
        } 
      }
    },
    all_drivers(internal) {
      if (this.allDrivers) {
        return this.allDrivers.map(o => o.attributes).filter(o => o.status_id == 1 && o.external != internal)
      }
    },
    all_trucks(internal) {
      if (this.allTrucks) {
        return this.allTrucks.filter(truck => truck.attributes.internal == internal).map(o => o.attributes)
      }
    },
    ...mapActions({
      getVehicles: 'Vehicle/index',
      getDrivers: 'Driver/index',
    })
  },
  mounted() {
    if (!this.allDrivers) { this.getDrivers() }
    if (!this.allTrucks) { this.getVehicles() }
  },
  computed: {
    some_won_items() {
      if (!this.win_all) {
        return this.last_deal.deal_items.filter(o => o.status == 'won').map(o => o.id)
      }
      return null
    },
    ...mapState({
      allDrivers: state => state.Driver.allDrivers,
      allTrucks: state => state.Vehicle.allVehicles,
    })
  },
  watch: {
    dialog(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.$emit('close')
      }
    },
    some_won_items(nv, ov) {
      this.setup_shipping_done = false
      if (nv) {

      } else if (nv == false) {

      }
    },
    win_all(nv, ov) {
      this.setup_shipping_done = false
      if (nv) {

      } else if (nv == false) {

      }
    }
  },
}
</script>